// frontend/src/askos/liveSessions/LiveSessionCard.js
//
// Dashboard-home widget: highlights the next upcoming or currently-live
// session. Same `.panel` visual shape as the other AskOS dashboard cards.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listLiveSessionsStudent, getMyAttendance } from '../../api/liveSessionsApi';

const LiveSessionCard = ({ slug }) => {
    const [session, setSession] = useState(null);
    const [loading, setLoading] = useState(true);
    const [myAttendance, setMyAttendance] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        Promise.all([
            listLiveSessionsStudent(slug, 'live'),
            listLiveSessionsStudent(slug, 'scheduled'),
        ])
            .then(([live, scheduled]) => setSession(live[0] || scheduled[0] || null))
            .catch(() => setSession(null))
            .finally(() => setLoading(false));
        getMyAttendance(slug).then(setMyAttendance).catch(() => setMyAttendance(null));
    }, [slug]);

    return (
        <article className="panel">
            <div className="panel-heading">
                <h3>Live Sessions</h3>
                <a href="#" onClick={e => { e.preventDefault(); navigate('/samkalp-ias/live-sessions'); }}>View All</a>
            </div>
            {loading && <p className="empty-note">Loading…</p>}
            {!loading && !session && <p className="empty-note">No upcoming live sessions right now.</p>}
            {session && (
                <div className="news-row" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 4 }}>
                    <strong>{session.topic}</strong>
                    <span>{session.faculty_name} {session.subject_label ? `· ${session.subject_label}` : ''}</span>
                    <small>
                        {session.status === 'live'
                            ? 'Live now'
                            : new Date(session.scheduled_start_utc).toLocaleString()}
                    </small>
                    <button
                        type="button"
                        className={session.status === 'live' ? 'primary-btn' : 'secondary-btn'}
                        style={{ marginTop: 6 }}
                        onClick={() => navigate(session.status === 'live' ? `/samkalp-ias/live/${session.id}` : '/samkalp-ias/live-sessions')}
                    >
                        {session.status === 'live' ? 'Join Now' : 'View Details'}
                    </button>
                </div>
            )}
            {myAttendance && (
                <p className="empty-note" style={{ marginTop: 10, marginBottom: 0 }}>
                    {myAttendance.sessions_attended > 0 ? (
                        <>You've attended <strong>{myAttendance.sessions_attended}</strong> session{myAttendance.sessions_attended === 1 ? '' : 's'} ·{' '}
                        <strong>{Math.round(myAttendance.total_minutes)}</strong> min total</>
                    ) : (
                        "You haven't attended any live sessions yet."
                    )}
                </p>
            )}
        </article>
    );
};

export default LiveSessionCard;
